export default {
    namespaced: true,
    state: {
        list: [],
    },
    actions: {
        add({ commit }, toast) {
            commit('ADD', toast);
        },
        remove({ commit }, index) {
            commit('REMOVE', index);
        }
    },
    mutations: {
        ADD( state, toast) {
            state.list.push(toast);
        },
        REMOVE( state, index ) {
            state.list.splice(index , 1);
        }
    },
}
